export const ENERGY_INGREDIENTS = [
  { id: 34, name: "Vitamin B12 (Methylcobalamin)", quantity: "0.05", nrv: "2000" },
  { id: 21, name: "Vitamin B2", quantity: "2", nrv: "0" },
  { id: 24, name: "Vitamin B6", quantity: "3", nrv: "214" },
  { id: 26, name: "Vitamin B9 (Folat)", quantity: "0.4", nrv: "200" },
  { id: 6, name: "Coenzyme Q10", quantity: "100", nrv: "0" },
  { id: 25, name: "Vitamin B7 (Biotin)", quantity: "0.075", nrv: "150" },
  { id: 22, name: "Vitamin B3 (Niacin)", quantity: "20", nrv: "125" },
  { id: 23, name: "Vitamin B5 (Pantothenic acid)", quantity: "6", nrv: "100" },
  { id: 19, name: "Vitamin B1", quantity: "2", nrv: "182" },
  { id: 39, name: "Magnesium", quantity: "300", nrv: "80" },
  { id: 11, name: "Iron", quantity: "5", nrv: "36" },
  { id: 16, name: "Potassium", quantity: "200", nrv: "10" },
];

export const IMMUNE_SYSTEM_INGREDIENTS = [
  { id: 27, name: "Vitamin C", quantity: "300", nrv: "375" },
  { id: 28, name: "Vitamin D3", quantity: "0.05", nrv: "1000" },
  { id: 31, name: "Zinc", quantity: "12", nrv: "120" },
  { id: 6, name: "Coenzyme Q10", quantity: "50", nrv: "0" },
  { id: 8, name: "Curcuma", quantity: "300", nrv: "0" },
  { id: 17, name: "Selenium", quantity: "0.1", nrv: "182" },
  { id: 18, name: "Vitamin A", quantity: "0.8", nrv: "100" },
  { id: 30, name: "Vitamin K", quantity: "0.05", nrv: "67" },
];

export const BEAUTY_INGREDIENTS = [
  { id: 29, name: "Vitamin E", quantity: "15", nrv: "125" },
  { id: 25, name: "Vitamin B7 (Biotin)", quantity: "0.15", nrv: "300" },
  { id: 31, name: "Zinc", quantity: "10", nrv: "100" },
  { id: 23, name: "Vitamin B5 (Pantothenic acid)", quantity: "6", nrv: "100" },
  { id: 27, name: "Vitamin C", quantity: "200", nrv: "250" },
  { id: 17, name: "Selenium", quantity: "0.055", nrv: "100" },
  { id: 24, name: "Vitamin B6", quantity: "2", nrv: "143" },
];

export const SLEEP_INGREDIENTS = [
  { id: 39, name: "Magnesium", quantity: "250", nrv: "67" },
  { id: 1, name: "Ashwagandha", quantity: "300", nrv: "0" },
  { id: 21, name: "Vitamin B2", quantity: "2", nrv: "0" },
  { id: 24, name: "Vitamin B6", quantity: "3", nrv: "214" },
  { id: 26, name: "Vitamin B9 (Folat)", quantity: "0.4", nrv: "200" },
  { id: 22, name: "Vitamin B3 (Niacin)", quantity: "20", nrv: "125" },
  { id: 23, name: "Vitamin B5 (Pantothenic acid)", quantity: "6", nrv: "100" },
  { id: 19, name: "Vitamin B1", quantity: "2", nrv: "182" },
  { id: 34, name: "Vitamin B12 (Methylcobalamin)", quantity: "0.05", nrv: "2000" },
];

export const SPORT_RECOVERY_INGREDIENTS = [
  { id: 39, name: "Magnesium", quantity: "250", nrv: "67" },
  { id: 17, name: "Selenium", quantity: "0.05", nrv: "91" },
  { id: 34, name: "Vitamin B12 (Methylcobalamin)", quantity: "0.05", nrv: "2000" },
  { id: 21, name: "Vitamin B2", quantity: "2", nrv: "0" },
  { id: 24, name: "Vitamin B6", quantity: "3", nrv: "214" },
  { id: 26, name: "Vitamin B9 (Folat)", quantity: "0.4", nrv: "200" },
  { id: 25, name: "Vitamin B7 (Biotin)", quantity: "0.075", nrv: "150" },
  { id: 22, name: "Vitamin B3 (Niacin)", quantity: "20", nrv: "125" },
  { id: 23, name: "Vitamin B5 (Pantothenic acid)", quantity: "6", nrv: "100" },
  { id: 27, name: "Vitamin C", quantity: "100", nrv: "125" },
  { id: 28, name: "Vitamin D3", quantity: "0.025", nrv: "500" },
  { id: 7, name: "Copper", quantity: "1", nrv: "100" },
  { id: 31, name: "Zinc", quantity: "12", nrv: "120" },
  { id: 6, name: "Coenzyme Q10", quantity: "100", nrv: "0" },
  { id: 16, name: "Potassium", quantity: "300", nrv: "15" },
  { id: 19, name: "Vitamin B1", quantity: "2", nrv: "182" },
  { id: 8, name: "Curcuma", quantity: "300", nrv: "0" },
  { id: 30, name: "Vitamin K", quantity: "0.05", nrv: "67" },
];

export const STRESS_INGREDIENTS = [
  { id: 34, name: "Vitamin B12 (Methylcobalamin)", quantity: "0.05", nrv: "2000" },
  { id: 21, name: "Vitamin B2", quantity: "4", nrv: "0" },
  { id: 24, name: "Vitamin B6", quantity: "6", nrv: "429" },
  { id: 26, name: "Vitamin B9 (Folat)", quantity: "0.4", nrv: "200" },
  { id: 25, name: "Vitamin B7 (Biotin)", quantity: "0.15", nrv: "300" },
  { id: 22, name: "Vitamin B3 (Niacin)", quantity: "40", nrv: "250" },
  { id: 23, name: "Vitamin B5 (Pantothenic acid)", quantity: "12", nrv: "200" },
  { id: 19, name: "Vitamin B1", quantity: "4", nrv: "364" },
  { id: 39, name: "Magnesium", quantity: "300", nrv: "80" },
  { id: 28, name: "Vitamin D3", quantity: "0.025", nrv: "500" },
  { id: 31, name: "Zinc", quantity: "12", nrv: "120" },
  { id: 30, name: "Vitamin K", quantity: "0.05", nrv: "67" },
  { id: 16, name: "Potassium", quantity: "300", nrv: "15" },
  { id: 17, name: "Selenium", quantity: "0.075", nrv: "136" },
];
